import React from "react";

const SendIcon = ({ size = 24, color = "#3249D7" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="42" height="42" rx="10" fill={color} />

      <g clipPath="url(#clip0)">
        <path
          d="M11.8758 19.5215C11.5954 19.4424 11.3478 19.2755 11.1691 19.0454C10.9905 18.8152 10.8903 18.5339 10.8832 18.2427C10.8761 17.9514 10.9626 17.6656 11.1298 17.427C11.2971 17.1885 11.5363 17.0098 11.8126 16.9172L30.211 10.9167C30.3315 10.8774 30.4605 10.8722 30.5838 10.9015C30.7072 10.9309 30.82 10.9938 30.9098 11.0832C30.9997 11.1726 31.0631 11.285 31.0932 11.4082C31.1232 11.5313 31.1186 11.6604 31.08 11.7811L25.0841 30.1887C24.9919 30.4654 24.8133 30.7052 24.5746 30.8728C24.3359 31.0404 24.0498 31.127 23.7582 31.1198C23.4666 31.1126 23.1851 31.0121 22.955 30.8329C22.7248 30.6537 22.5583 30.4054 22.4798 30.1245L20.421 21.5711L11.8758 19.5215Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d="M30.9113 11.082L20.4219 21.5714"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <defs>
        <clipPath id="clip0">
          <rect width="22" height="22" fill="white" transform="translate(10 10)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SendIcon;